import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGallery$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGallery extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '064c4e93245dd206b201f8551b24499d681d1ff8', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'df964981779a4479cfa60dcdbd27bb38201ac2f2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9cbf82429c35566dc8c3ff2b07179c954f6723c9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.563 4a.44.44 0 0 0-.438.438v2.625c0 .241.196.437.438.437h.874a.44.44 0 0 0 .438-.437V4.438A.44.44 0 0 0 4.438 4zm14.875 14a.44.44 0 0 0 .437-.437v-2.625a.44.44 0 0 0-.437-.438h-.875a.44.44 0 0 0-.438.438v2.624c0 .242.196.438.438.438zM15.375 4.438c0-.242.196-.438.438-.438h2.624c.242 0 .438.196.438.438v2.625a.44.44 0 0 1-.437.437h-2.625a.44.44 0 0 1-.438-.437zM6.188 18a.44.44 0 0 0 .437-.437v-2.625a.44.44 0 0 0-.437-.438H3.563a.44.44 0 0 0-.438.438v2.624c0 .242.196.438.438.438zm.437-13.562c0-.242.196-.438.438-.438h6.125c.241 0 .437.196.437.438v2.625a.44.44 0 0 1-.437.437H7.062a.44.44 0 0 1-.437-.437zM14.938 18a.44.44 0 0 0 .437-.437v-2.625a.44.44 0 0 0-.437-.438H8.811a.44.44 0 0 0-.437.438v2.624c0 .242.196.438.438.438zM3.124 9.688c0-.242.196-.438.438-.438h6.124c.242 0 .438.196.438.438v2.624a.44.44 0 0 1-.437.438H3.561a.44.44 0 0 1-.437-.437zm9.188-.438a.44.44 0 0 0-.438.438v2.624c0 .242.196.438.438.438h6.124a.44.44 0 0 0 .438-.437V9.687a.44.44 0 0 0-.437-.437z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-gallery", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-gallery"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-gallery":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGallery$1);
            }
            break;
    } });
}

const CosmosIconGallery = CosmosIconGallery$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGallery, defineCustomElement };
